var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',[_c('b-col',[_c('h1',{staticClass:"sr-only"},[_vm._v("Dashboard")])])],1),_c('kpi-cards'),_c('dashboard-grid')],1)}
var staticRenderFns = []

export { render, staticRenderFns }